module.exports = __webpack_public_path__ + "static/img/B (17).ae06ac88.png";